<template>
  <div class="input">
    <label :class="{ isDisabled: disabled }">
      <input
        type="checkbox"
        @focus="isFocused = true"
        @blur="isFocused = false"
        @change="change"
        v-model="checked"
        :required="required"
        :disabled="disabled"
        :value="val"
      />
      <span class="mimicry">
        <svg data-testid="service-checkbox" class="mimicry-icon" viewBox="0 0 24 24">
          <path class="mimicry-checkmark" d="M4.91,12.09L9,16.17L19,7" />
        </svg>
      </span>
      <div class="text">
        <slot name="label"></slot>
      </div>
    </label>
    <span v-if="message" class="error">{{ message }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array as () => Array<string>,
      default: () => [],
    },
    val: {
      type: Object,
    },
    message: {
      type: String,
    },
  },
  data() {
    return {
      isFocused: false,
      checkedProxy: false,
    };
  },
  computed: {
    checked: {
      get(): string[] {
        return this.value;
      },
      set(val: boolean) {
        this.checkedProxy = val;
      },
    },
  },
  methods: {
    change: function () {
      this.$emit("input", this.checkedProxy);
    },
  },
});
</script>

<style lang="scss" scoped>
.input {
  position: relative;
  color: #4d4d4d;
}

label {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  word-break: break-all;
  font-weight: bold;
  font-size: 24px;
  &:not(.isDisabled):hover {
    .mimicry {
      border-color: $color-primary-blue;
      background-color: $color-secondary-brightblue;
    }
  }

  &.isDisabled {
    cursor: not-allowed;
    color: $color-secondary-bluegray-50;
    .mimicry {
      border-color: $color-secondary-bluegray-50;
    }
  }
}

input[type="checkbox"] {
  display: none;
  &:checked {
    & + .mimicry {
      border-color: $color-primary-blue;
      background-color: $color-primary-blue;
      .mimicry-checkmark {
        animation: appear 0.3s forwards;
      }
    }
  }
}

.mimicry {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  border: 2px solid $color-primary-gray;
  border-radius: 2px;
  transition: all 0.3s ease;

  &-icon {
    top: -5px;
    left: -5px;
    position: relative;
    width: 24px;
    height: 24px;
  }

  &-checkmark {
    stroke-width: 3px;
    fill: none;
    stroke: #fff;
    stroke-dasharray: 20;
    stroke-dashoffset: 60;
    animation: disappear 0.3s forwards;
  }
}

.text {
  margin-left: 12px;
}

.error {
  font-weight: bold;
  color: red;
}

// Safari bug currently with stroke-dashoffset, may want to change disappear to 40 - > 60
@keyframes appear {
  from {
    stroke-dashoffset: 60;
  }

  to {
    stroke-dashoffset: 40;
  }
}

@keyframes disappear {
  from {
    stroke-dashoffset: 40;
  }

  to {
    stroke-dashoffset: 60;
  }
}
</style>
